import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { BareButton } from '@calendly/ui/components/bare-button'
import styled from 'astroturf/react'
import { OnetrustSettingsButton } from '@calendly/onetrust/redux'
import { Loader } from '@calendly/ui/components/loader'
import { EventTypeDescription, EventTypeLocation, Duration, Price, MainPanel, BackButton } from '@calendly/booking-kit'
import { parseQuery } from '@calendly/http-tools'
import { ErrorMessage } from '@calendly/form'
import { useFlag } from '@calendly/feature-check-react'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue600))'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { BodyText, TitleText } from '@calendly/ui/components/typography'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'

import { useI18n } from 'locales'
import GoogleAnalytics from 'services/analytics/google'
import EmbedAnalytics from 'services/analytics/embed'
import FbPixel from 'services/analytics/facebook_pixel'
import DetailsContainer from 'components/enter_details/details_container'
import FormerDetails from 'components/rescheduling/details'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'
import Container from 'components/layout/container'
import SidePanel from 'components/layout/side_panel'
import ContentWrapper from 'components/layout/content_wrapper'
import Profile from 'components/profile'
import BookingForm from 'components/enter_details/booking_form'
import ConfirmationRedirect from 'components/confirmation/redirect'
import DetailsForm from 'components/details_form'
import {
  isPollSelector
} from 'selectors/event_type'
import { setEventType, eventTypeSelector } from 'root-api'
import {
  timezoneSelector,
  timeNotationSelector,
  showRedirectHintSelector,
  isPublisherSelector
} from 'selectors'
import {
  autofillDataSelector,
  schedulingParamsSelector,
  showExternalRedirectSelector,
  showVerificationCodeChallengeSelector,
  verificationCodeErrorSelector
} from 'selectors/scheduling'
import { showTimezonePopupSelector } from 'selectors/adhoc'
import { currentInviteeSelector, isReschedulingSelector } from 'selectors/current_invitee'
import { nameSelector } from 'selectors/invitee'
import { isEmbeddedSelector } from 'selectors/embed'
import autofill from 'actions/autofill'
import { navigateBack } from 'actions/back'
import { trackFingerprint } from 'actions/tracking'
import {
  buildSpot,
  formatEnterDetailsSpotHeadingLine,
  formatRescheduleEnterDetailsRangeLine
} from 'services/spot_time'
import TimezonePopup from 'components/timezone_popup'
import { useProfile } from 'components/use_profile'
import { EmailVerification } from 'components/email_verification'
import { schedule, resetVerificationCodeChallenge, submitScheduling } from 'actions/scheduling'
import { useSendSegmentEvent } from 'hooks/use-segment-events'

import { useOrganizationLogoUrl } from '../use_organization'
import PackageSession from '../details/packages_session'
import { usePurchasedPackageData } from '../../hooks/usePurchasedPackageData'

import BookingError from './booking_error'
import FormTitle from './form_title'
import CollapsibleSpotTimes from './collapsible_spot_times'

import { BookingRedesignBackLink } from 'components/booking_redesign_back_link'
import { BookingRedesignPhoneBackButton } from 'components/booking_redesign_phone_back_button'
import { EnterDetailsRescheduleSummary } from './reschedule_heading_summary'
import _RedirectHint from "index-RedirectHint.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=RedirectHint";
import _StyledOnetrustSettingsButton from "index-StyledOnetrustSettingsButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=StyledOnetrustSettingsButton";
import _PreferencesSubText from "index-PreferencesSubText.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=PreferencesSubText";
import _EnterDetailsSpotSummaryWrap from "index-EnterDetailsSpotSummaryWrap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=EnterDetailsSpotSummaryWrap";
import _SidebarRescheduleSummaryWrap from "index-SidebarRescheduleSummaryWrap.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=SidebarRescheduleSummaryWrap";
import _NavigateBackContainer from "index-NavigateBackContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=NavigateBackContainer";
import _EditPreferredTimesButton from "index-EditPreferredTimesButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=EditPreferredTimesButton";
import _LinksContainer from "index-LinksContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=LinksContainer";
import _StyledDiv from "index-StyledDiv.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=StyledDiv";
import _FooterDiv from "index-FooterDiv.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=FooterDiv";
import _VerificationContentWrapper from "index-VerificationContentWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=VerificationContentWrapper";
import _VerificationBackButton from "index-VerificationBackButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/index.js?styleId=VerificationBackButton";


const RedirectHint = /*#__PURE__*/styled('small', null, {
  displayName: "RedirectHint",
  styles: _RedirectHint
})

const StyledOnetrustSettingsButton = /*#__PURE__*/styled(OnetrustSettingsButton, null, {
  displayName: "StyledOnetrustSettingsButton",
  styles: _StyledOnetrustSettingsButton
})

const PreferencesSubText = /*#__PURE__*/styled('div', null, {
  displayName: "PreferencesSubText",
  styles: _PreferencesSubText
})

const EnterDetailsSpotSummaryWrap = /*#__PURE__*/styled('div', null, {
  displayName: "EnterDetailsSpotSummaryWrap",
  styles: _EnterDetailsSpotSummaryWrap
})

const SidebarRescheduleSummaryWrap = /*#__PURE__*/styled('div', null, {
  displayName: "SidebarRescheduleSummaryWrap",
  styles: _SidebarRescheduleSummaryWrap
})

const NavigateBackContainer = /*#__PURE__*/styled('div', null, {
  displayName: "NavigateBackContainer",
  styles: _NavigateBackContainer
})

const EditPreferredTimesButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "EditPreferredTimesButton",
  styles: _EditPreferredTimesButton,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTabletDown: useDeviceType('isTabletDown')
  })
})

const LinksContainer = /*#__PURE__*/styled('div', null, {
  displayName: "LinksContainer",
  styles: _LinksContainer
})

const StyledDiv = /*#__PURE__*/styled('div', null, {
  displayName: "StyledDiv",
  styles: _StyledDiv
})

const FooterDiv = /*#__PURE__*/styled('div', null, {
  displayName: "FooterDiv",
  styles: _FooterDiv,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const VerificationContentWrapper = /*#__PURE__*/styled(ContentWrapper, null, {
  displayName: "VerificationContentWrapper",
  styles: _VerificationContentWrapper,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const VerificationBackButton = /*#__PURE__*/styled(BackButton, null, {
  displayName: "VerificationBackButton",
  styles: _VerificationBackButton,
  attrs: props => ({
    ...props,
    isDesktopUp: useDeviceType('isDesktopUp')
  })
})

const CookieSettingsButton = () => {
  const isTabletDown = useDeviceType('isTabletDown')

  if (!isTabletDown) return null

  return <StyledOnetrustSettingsButton />
}

const checkIfIframe = () => window.location !== window.parent.location

const FooterLinks = () => {
  const isTabletDown = useDeviceType('isTabletDown')
  const embedSelector = useSelector(isEmbeddedSelector)
  const isEmbedded = checkIfIframe() || embedSelector

  if (!isTabletDown) return null

  if (isEmbedded) return <LinksContainer><CookieSettingsButton /></LinksContainer>

  return (
    <LinksContainer>
      <CookieSettingsButton />
    </LinksContainer>
  )
}

const RenderProfile = ({ name, avatar, logoUrl }) => {
  const { i18n } = useI18n()
  const match = useRouteMatch()
  const dispatch = useDispatch()
  const onNavigateBackClick = () => dispatch(navigateBack(match))
  const eventType = useSelector(eventTypeSelector)
  const isPoll = useSelector(isPollSelector)
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  if (!eventType) return null

  const isFlatSpotpicker = eventType.spotpicker_type === 'FlatSpotpicker'
  const nameToShow = eventType.type === 'AdhocEventType' && eventType.publishers_list ? eventType.publishers_list : name
  const avatarToShow = eventType.type === 'AdhocEventType' && eventType.publisher_avatar ? eventType.publisher_avatar : avatar

  if (bookingAppRedesign) {
    return (
      <>
        {isPoll && (
          <NavigateBackContainer>
            <EditPreferredTimesButton onClick={onNavigateBackClick}>
              {i18n.t('booking.templates.poll.edit_times')}
            </EditPreferredTimesButton>
          </NavigateBackContainer>
        )}
        <Profile
          avatar={avatarToShow}
          name={nameToShow}
          logoUrl={logoUrl}
          eventTypeName={eventType.name}
          reduced={!isFlatSpotpicker}
          sidebar
        />
      </>
    )
  }

  return (
    <>
      <NavigateBackContainer>
        <BackButton
          onClick={onNavigateBackClick}
          withCompanyLogo={Boolean(logoUrl) && !isPoll}
        />
        {isPoll && (
          <EditPreferredTimesButton onClick={onNavigateBackClick}>
            {i18n.t('booking.templates.poll.edit_times')}
          </EditPreferredTimesButton>
        )}
      </NavigateBackContainer>
      <Profile
        avatar={avatarToShow}
        name={nameToShow}
        logoUrl={logoUrl}
        eventTypeName={eventType.name}
        reduced={!isFlatSpotpicker}
        sidebar
      />
    </>
  )
}

const RenderOrganization = () => {
  const logoUrl = useOrganizationLogoUrl()

  return (
    <RenderProfile
      logoUrl={logoUrl}
    />
  )
}

const ProfileWrapper = () => {
  const profile = useProfile()

  if (profile === undefined) return <Loader />

  if (profile) {
    return (
      <RenderProfile
        avatar={profile.avatar_url}
        name={profile.name}
        logoUrl={profile.logo_url}
      />
    )
  }

  return <RenderOrganization />
}

const Panels = ({ hideMeetingDetailsSidebar = false }) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isPhone = useDeviceType('isPhone')
  const isTabletDown = useDeviceType('isTabletDown')
  const { search } = useLocation()
  const durationQuery = parseQuery(search).duration
  const durationParam = durationQuery ? Number(durationQuery) : undefined
  const match = useRouteMatch()
  const autofillData = useSelector(autofillDataSelector)
  const eventType = useSelector(eventTypeSelector)
  const invitee = useSelector(currentInviteeSelector)
  const isPublisher = useSelector(isPublisherSelector)
  const inviteeName = useSelector(nameSelector)
  const isRescheduling = useSelector(isReschedulingSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const timezone = useSelector(timezoneSelector)
  const showExternalRedirect = useSelector(showExternalRedirectSelector)
  const isPoll = useSelector(isPollSelector)
  const showRedirectHint = useSelector(showRedirectHintSelector)
  const { duration_options: durationOptions } = eventType
  const duration = eventType.durationOverride || durationParam || eventType.duration
  const timezoneForSpotSummary = timezone || invitee?.timezone
  const spot = buildSpot(match.params.spotStartTime, duration, timezoneForSpotSummary)
  const defaultDescriptionValue = '<p><br></p>'
  const dateLocale = invitee?.locale || eventType.locale || i18n.locale

  // Fetch purchased package data to display session count
  const { purchasedPackage, currentSession, numSessions } = usePurchasedPackageData(eventType.uuid)

  const hasMeetingPackage = purchasedPackage || invitee?.event?.package_fulfillment_uuid

  useEffect(() => {
    GoogleAnalytics.userTrackEvent('invitee_select_time', eventType.name)
    FbPixel.trackCustom('invitee_select_time', { event_type_name: eventType.name })
    EmbedAnalytics.track('date_and_time_selected')
    dispatch(autofill(eventType))
  }, [dispatch, eventType])

  useEffect(() => {
    dispatch(trackFingerprint())
  }, [dispatch])

  useEffect(() => {
    if (duration !== eventType.duration && durationOptions?.includes(duration)) {
      dispatch(setEventType({ duration, durationOverride: duration }))
    }
  }, [duration, durationOptions, eventType.duration, dispatch])

  const rescheduleFormerLine = isRescheduling && invitee?.event
    ? formatRescheduleEnterDetailsRangeLine(invitee.event, timeNotation, invitee.timezone, dateLocale)
    : ''
  const rescheduleNewLine = isRescheduling
    ? formatRescheduleEnterDetailsRangeLine(spot, timeNotation, timezoneForSpotSummary, dateLocale)
    : ''
  const rescheduleFormerTimeLabel = isPublisher
    ? `${i18n.t('booking.templates.former_time')} (${inviteeName})`
    : i18n.t('booking.templates.former_time')
  const showRescheduleSummaryInSidebar =
    bookingAppRedesign &&
    !isTabletDown &&
    !isPoll &&
    isRescheduling &&
    rescheduleFormerLine &&
    rescheduleNewLine

  return (
    <>
      {hideMeetingDetailsSidebar ? (
        <VisuallyHidden><h1>{eventType.name}</h1></VisuallyHidden>
      ) : (
        <SidePanel narrow>
          <ProfileWrapper />
          <DetailsContainer>
            <PackageSession currentSession={currentSession} numSessions={numSessions} />
            <Duration value={eventType.duration} />
            <EventTypeLocation eventType={eventType} />
            {!hasMeetingPackage && (<Price source={eventType} />)}
            {!bookingAppRedesign && (
              isPoll
                ? <CollapsibleSpotTimes />
                : (
                  <>
                    <EventTime source={spot} timezone={timezoneForSpotSummary} timeNotation={timeNotation} />
                    <Timezone value={timezoneForSpotSummary} />
                  </>
                )
            )}
          </DetailsContainer>
          {eventType.description !== defaultDescriptionValue && (
            <EventTypeDescription isConfirmationPage>{eventType.description}</EventTypeDescription>
          )}
          {bookingAppRedesign && isRescheduling && !isPoll ? (
            showRescheduleSummaryInSidebar ? (
              <SidebarRescheduleSummaryWrap data-component="sidebar-reschedule-summary">
                <EnterDetailsRescheduleSummary
                  variant="sidebar"
                  formerTimeLabel={rescheduleFormerTimeLabel}
                  newTimeLabel={i18n.t('booking.templates.new_time')}
                  formerLineText={rescheduleFormerLine}
                  newLineText={rescheduleNewLine}
                />
              </SidebarRescheduleSummaryWrap>
            ) : null
          ) : (
            <FormerDetails crossedItems />
          )}
        </SidePanel>
      )}
      <MainPanel>
        <ContentWrapper>
          <DetailsForm>
            {bookingAppRedesign && (isPhone ? (
              <BookingRedesignPhoneBackButton onClick={() => dispatch(navigateBack(match))} />
            ) : (
              <BookingRedesignBackLink onClick={() => dispatch(navigateBack(match))} />
            ))}
            <div
              data-component="enter-details-heading-group"
              style={
                bookingAppRedesign && isPhone
                  ? { width: '100%', textAlign: 'center' }
                  : undefined
              }
            >
              <FormTitle isPoll={isPoll} />
              {bookingAppRedesign && isTabletDown && !isPoll && isRescheduling && rescheduleFormerLine && rescheduleNewLine && (
                <EnterDetailsRescheduleSummary
                  formerTimeLabel={rescheduleFormerTimeLabel}
                  newTimeLabel={i18n.t('booking.templates.new_time')}
                  formerLineText={rescheduleFormerLine}
                  newLineText={rescheduleNewLine}
                />
              )}
              {bookingAppRedesign && !isPoll && !isRescheduling && (
                <EnterDetailsSpotSummaryWrap data-component="enter-details-spot-summary">
                  <BodyText size="medium" color={textColorLevel2}>
                    {formatEnterDetailsSpotHeadingLine(spot, timeNotation, timezoneForSpotSummary, dateLocale)}
                  </BodyText>
                </EnterDetailsSpotSummaryWrap>
              )}
            </div>
            {isPoll && (
              <PreferencesSubText>
                {i18n.t('booking.templates.poll.preferences_subtext')}
              </PreferencesSubText>
            )}
            {autofillData && <BookingForm />}
            {showRedirectHint && <RedirectHint>{i18n.t('booking.templates.redirect.hint')}</RedirectHint>}
            {showExternalRedirect && <ConfirmationRedirect />}
            <BookingError />
          </DetailsForm>
          <FooterLinks />
        </ContentWrapper>
      </MainPanel>
    </>
  )
}

const EnterVerificationCode = () => {
  const { i18n } = useI18n()
  const schedulingParams = useSelector(schedulingParamsSelector)
  const { spotStartTime, formData, paymentApi, requestId, client, numRetries } = schedulingParams
  const { invitee: { email: formDataEmail } } = formData
  const verificationCodeError = useSelector(verificationCodeErrorSelector)
  const [submitting, setSubmitting] = useState(false)
  const dispatch = useDispatch()
  const sendSegmentEvent = useSendSegmentEvent()
  const eventType = useSelector(eventTypeSelector)
  const asyncBookingEnabled = useFlag('scheduling_platform_async_booking', false)

  useEffect(() => {
    if (eventType) {
      sendSegmentEvent('event_type', eventType.owning_user, eventType.id, 'otp_email_verification', eventType.unavailability_reason?.code)
    }
  }, [sendSegmentEvent, eventType])

  const onNavigateBackClick = () => dispatch(resetVerificationCodeChallenge())

  const resetErrors = () => {
    dispatch({
      type: 'SHOW_VERIFICATION_CODE_CHALLENGE',
      payload: { schedulingParams, errorMessage: null }
    })
  }

  const handleSubmit = (result) => {
    setSubmitting(true)
    if (asyncBookingEnabled) {
      const newRequestId = `${requestId}-${result.code}` // need a new request id, otherwise its treated as a duplicate booking
      dispatch(submitScheduling(spotStartTime, formData, paymentApi, null, newRequestId, client, asyncBookingEnabled, result.code))
        .finally(() => setSubmitting(false))
    } else {
      dispatch(schedule(spotStartTime, formData, paymentApi, requestId, client, numRetries, result.code))
        .finally(() => setSubmitting(false))
    }
  }

  const labelText = i18n.t('errors.booking.verification.verify_email_description', { email: formDataEmail?.value })

  return (
    <StyledDiv>
      <NavigateBackContainer>
        <VerificationBackButton
          onClick={onNavigateBackClick}
        />
      </NavigateBackContainer>
      <VerificationContentWrapper>
        <DetailsForm>
          <TitleText level={2} as="h1" size="large">{i18n.t('errors.booking.verification.verify_email')}</TitleText>
          {
            submitting
              ? <Loader />
              : <EmailVerification labelText={labelText} handleSubmit={handleSubmit} error={verificationCodeError} reset={resetErrors} />
          }
          {!!verificationCodeError && <ErrorMessage message={verificationCodeError} />}
        </DetailsForm>
      </VerificationContentWrapper>
      <FooterDiv>
        <StyledOnetrustSettingsButton />
      </FooterDiv>
    </StyledDiv>
  )
}

const EnterDetails = () => {
  const showTimezonePopup = useSelector(showTimezonePopupSelector)
  const showVerificationCodeChallenge = useSelector(showVerificationCodeChallengeSelector)
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isTabletDown = useDeviceType('isTabletDown')
  const hideMeetingDetailsSidebar = bookingAppRedesign && isTabletDown

  return (
    <Container
      expanded
      hideBranding={bookingAppRedesign}
      hiddenSidebar={hideMeetingDetailsSidebar}
    >
      {showVerificationCodeChallenge ? <EnterVerificationCode /> : <Panels hideMeetingDetailsSidebar={hideMeetingDetailsSidebar} />}
      {showTimezonePopup && <TimezonePopup step="enter_details" />}
    </Container>
  )
}

export default EnterDetails
